var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message select-reservation-day" },
    [
      Object.keys(_vm.reservationDetail).length > 0
        ? _c("DayList", {
            attrs: { reservationDetail: _vm.reservationDetail, data: _vm.data },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }